<template>
  <router-link :to="`/news/${news.id}`">
    <div class="news-card">
      <div class="thumbnail-box">
        <img :src="news.thumbnail" alt="thumbnail" />
      </div>
      <div class="section">
        <NewsCardDate class="date" :date="news.publish_date" />
        <div class="description">{{ news.short_description }}</div>
      </div>
      <span class="more">more+</span>
    </div>
  </router-link>
</template>

<script>
import NewsCardDate from "./NewsCardDate";

export default {
  components: {
    NewsCardDate
  },
  props: {
    news: Object
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}

.news-card {
  padding: 10px;
  color: #595959;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 9px;

  .thumbnail-box {
    display: flex;
    justify-content: center;
  }

  img {
    height: 175px;
    margin-bottom: 7px;
  }

  .section {
    display: flex;
    flex-direction: row;

    .date {
      border-right: 1px solid #979797;
      padding-right: 10px;
    }

    .description {
      padding: 9px;
      font-size: 18px;
      font-weight: bold;
      line-height: 19px;
      letter-spacing: 1.75px;
      line-height: 1.5;
      flex: 1;
    }
  }
  .more {
    font-size: 12px;
    color: #c4cb7a;
    align-self: flex-end;
  }
}
</style>
